import { PulseBaseProvider } from '../../base-classes';


const _roadForecastApi = '/api/road/forecast/v1';
const _roadForecastCacheKey = 'roadForecastByLocation';

export class RoadForecastProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_roadForecastCacheKey] = this.roadForecastSyncer.bind(this);
    }

    async roadForecastSyncer(params) {
        const { id, syncParams, resolve, reject } = params;
        const { speedUnit, pressureUnit, temperatureUnit, distanceUnit, directionUnit, precipUnit, cultureInfo, verbose, latitude, longitude } = syncParams;
        let queryParams = {
            cultureInfo,
            verbose
        };

        const apiPath = `${_roadForecastApi}/locationtype=latitudelongitude/location=${latitude},${longitude}`;
        
        return await super.syncData(syncParams.key, id, queryParams, apiPath, resolve, reject, null, syncParams.pulseApi);
    }

    async getRoadForecastByLocation(stdParameters, latitude, longitude, speedUnit, pressureUnit, temperatureUnit, distanceUnit, directionUnit, precipUnit, verbose, refresh) {
        const syncParams = {
            cultureInfo: stdParameters?.cultureInfo,
            latitude,
            longitude,
            speedUnit, 
            pressureUnit, 
            temperatureUnit, 
            distanceUnit, 
            directionUnit, 
            precipUnit,
            verbose
        };
        const id = JSON.stringify(syncParams);
        if (refresh) {
            const key = _roadForecastCacheKey;
            this.storage.remove({
                key,
                id
            });
        }
        return await super.loadFromStorage(_roadForecastCacheKey, id, syncParams);
    }
}
